import styled from 'styled-components';
import {IoIosArrowDroprightCircle} from 'react-icons/io';

export const IoArrow = styled(IoIosArrowDroprightCircle)`
  color: #5705A9;
`
